import React, { PureComponent } from 'react'
import IconTwitter from '../Icons/IconTwitter'
import IconLinkedIn from '../Icons/IconLinkedIn'
import IconGitHub from '../Icons/IconGitHub'
import IconEmail from '../Icons/IconEmail'
import IconInstagram from '../Icons/IconInstagram'

const SocialContainer = ({ className, textual = false } = props) => (
  <div className={`social-container ${className}`}>
    <ul className={`${textual ? 'textual' : ''}`}>
      {textual && (
        <li>
          <IconEmail textual={textual} className={'meta-link'} />
        </li>
      )}
      <li>
        <IconLinkedIn textual={textual} className={'meta-link'} />
      </li>
      <li>
        <IconGitHub textual={textual} className={'meta-link'} />
      </li>
      <li>
        <IconTwitter textual={textual} className={'meta-link'} />
      </li>
      <li>
        <IconInstagram textual={textual} className={'meta-link'} />
      </li>
    </ul>
  </div>
)

export { SocialContainer }



// WEBPACK FOOTER //
// ./src/components/Social/SocialContainer.js